
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../api/axios';

const ConfirmEmailPage = () => {
    const { token } = useParams();
    const [message, setMessage] = useState('Подтверждение...');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (token) {
            apiClient.get(`/confirm-email/${token}`)
                .then(response => {
                    setMessage(response.data.message);
                })
                .catch(err => {
                    setError(true);
                    if (err.response && err.response.data && err.response.data.detail) {
                        setMessage(err.response.data.detail);
                    } else {
                        setMessage('Произошла ошибка при подтверждении email.');
                    }
                });
        }
    }, [token]);

    return (
        <div className="container mt-5">
            <div className={`alert ${error ? 'alert-danger' : 'alert-success'}`}>
                {message}
            </div>
        </div>
    );
};

export default ConfirmEmailPage;
